import { render, staticRenderFns } from "./bStore_orders.vue?vue&type=template&id=15784040"
import script from "./bStore_orders.vue?vue&type=script&lang=js"
export * from "./bStore_orders.vue?vue&type=script&lang=js"
import style0 from "./bStore_orders.vue?vue&type=style&index=0&id=15784040&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports